import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import styles from "./Login.module.css";
import msgStyles from "../components/Messages.module.css";

function Login() {
    // Changed 'username' to 'identifier' to accommodate email or username login
    const [form, setForm] = useState({ identifier: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth(); // Your AuthContext's login function

    const from = location.state?.from?.pathname || "/";

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            // Send 'identifier' (username or email) and password to the backend
            const res = await axios.post("https://deenroute-backend-908197786741.africa-south1.run.app/api/auth/login", {
                identifier: form.identifier, // This sends the identifier
                password: form.password,
            });

            // The backend's /api/auth/login endpoint should return
            // uid, username, email, score, and token.
            const userData = {
                uid: res.data.uid,
                username: res.data.username,
                email: res.data.email,
                score: res.data.score,
                token: res.data.token,
            };

            // Call the login function from AuthContext with all the user data
            login(userData.token, userData.uid, userData.username, userData.email, userData.score);

            navigate(from, { replace: true }); // Redirect back to the intended page or home
        } catch (err) {
            // Display error from backend if available, otherwise a generic message
            setError(err.response?.data?.error || "Login failed. Please check your credentials.");
            console.error("Login API call failed:", err.response ? err.response.data : err.message, err);
        } finally {
            setLoading(false); // Always set loading to false after attempt
        }
    };

    return (
        <div
            className={styles.background}
            style={{ backgroundImage: `url("/images/loginsignup.jpg")` }}
        >
            <div className={styles.overlay}></div>
            <div className={styles.container}>
                <h2 className={styles.title}>Login</h2>
                {error && <p className={msgStyles.error}>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <input
                        className={styles.input}
                        type="text"
                        name="identifier" // Name changed to identifier
                        placeholder="Username or Email" // Placeholder updated
                        value={form.identifier}
                        onChange={handleChange}
                        required
                    />
                    <input
                        className={styles.input}
                        type="password"
                        name="password"
                        placeholder="Password"
                        value={form.password}
                        onChange={handleChange}
                        required
                    />
                    <button type="submit" className={styles.button} disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;